import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  checkboxWrapper: {
    position: 'relative',
    width: 24,
    height: 24,
  },
  hiddenInputCheckbox: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    zIndex: 1,
    top: 0,
    left: 0,
    margin: 0,
    appearance: 'none',
  },
  substituteStyledCheckbox: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: 4,
    backgroundColor: theme.colors.dark.darkSlateBlue,
  },
  checkMarkWrapper: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export const useStylesSvgIcon = makeStyles(theme => ({
  root: {
    width: 16,
    color: theme.colors.orange.orange,
  },
}));
